import { SmartImportDraftRow, StandardImportDraftSession } from '../types';

export function buildDraftInput(
  rows: SmartImportDraftRow[],
  sessions: StandardImportDraftSession[]
) {
  return {
    rows: rows.map((row) => ({
      rowRef: row.rowRef,
      include: row.include,
      archaeologicalDescriptionTarget: row.archaeologicalDescriptionTarget,
      find: {
        name: row.find.name,
        evId: row.find.evId,
        foundAt: row.find.foundAt,
        description: row.find.description,
        era: row.find.era?.trim().toLocaleLowerCase() ?? null,
        type: row.find.type,
        note: row.find.note,
        siteId: row.find.siteId,
        material: row.find.material,
        localization: row.find.localization,
        longitude: row.find.longitude,
        latitude: row.find.latitude,
        visibility: row.find.visibility,
        tags: row.find.tags,
      },
    })),
    sessions: sessions.map((session) => ({
      sessionRef: session.sessionRef,
      include: session.include,
    })),
  };
}
